import {isValid as isValidDate} from 'date-fns/isValid';

import {formatDate} from '@edna/utils';

import {ECalendarType, TCalendarDate, TCalendarType, isRangeValue} from '../Calendar';
import {TDatePickerValue} from './types';

const formatInputValue = (value: string = '') => {
  const cleanValue = value.replaceAll(/\D+/g, '');

  if (cleanValue.length > 4) {
    return `${cleanValue.substring(0, 2)}.${cleanValue.substring(2, 4)}.${cleanValue.substring(4, 8)}`;
  }

  if (cleanValue.length > 2) {
    return `${cleanValue.substring(0, 2)}.${cleanValue.substring(2)}`;
  }

  return cleanValue;
};

const formatInputDate = (date?: Date | null) =>
  date ? formatDate(date, {format: 'dd.MM.yyyy'}) : '';

const isDatePickerValue = (value: TCalendarDate): value is TDatePickerValue =>
  isRangeValue(value) ? !!value.startDate && !!value.endDate : !!value;

const getDefaultValue = (value: any, calendarType: TCalendarType) => {
  if (!value) {
    return {startDate: null, endDate: null};
  }

  if (calendarType === ECalendarType.DATE_RANGE) {
    const {startDate, endDate} = value;

    return {
      startDate: isValidDate(startDate) ? startDate : null,
      endDate: isValidDate(endDate) ? endDate : null,
    };
  }

  return {startDate: isValidDate(value) ? value : null, endDate: null};
};

export {formatInputValue, formatInputDate, getDefaultValue, isDatePickerValue};
